@if (mostRecentDateData(); as recentData) {
  <div class="mobile-table-container">
    <div class="mobile-table">
      <table mat-table [dataSource]="tableDataSource()">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Value</th>
          <td
            mat-cell
            *matCellDef="let element"
            [matTooltip]="element.tooltip || ''"
          >
            {{ element.name }}
          </td>
        </ng-container>

        <!-- Value Column -->
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef>
            {{ recentData.date | localizedDate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            [class.weekend-data]="recentData.isWeekend"
          >
            {{ emptyValueCheck(element.value) }}
          </td>
        </ng-container>

        <!-- Icon Column -->
        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <sh-icon
              [icon]="'arrow-line-right-s'"
              button
              (click)="onRowClick(element)"
              class="clickable-icon"
              [attr.aria-label]="'Navigate to details for ' + element.name"
            >
            </sh-icon>
          </td>
        </ng-container>

        <!-- Header and Row Definitions -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
}
